module.exports = __webpack_public_path__ + "img/coming_soon.1a203922.png";